"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _events = _interopRequireDefault(require("events"));

var _store = _interopRequireDefault(require("store"));

var _keyring = _interopRequireDefault(require("./keyring"));

var _threeIdProvider = _interopRequireDefault(require("./threeIdProvider"));

var _didJwt = _interopRequireDefault(require("did-jwt"));

var _ipfsDidDocument = _interopRequireDefault(require("ipfs-did-document"));

var _idBlockchainUtils = require("3id-blockchain-utils");

var _utils = require("./utils");

var DID_METHOD_NAME = '3';

var IdentityWallet =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of IdentityWallet
   *
   * @param     {Function}  getConsent              The function that is called to ask the user for consent
   * @param     {Object}    config                  The configuration to be used
   * @param     {String}    config.seed             The seed of the identity, 32 hex string
   * @param     {String}    config.authSecret       The authSecret to use, 32 hex string
   * @param     {String}    config.externalAuth     External auth function, directly returns key material, used to migrate legacy 3box accounts
   * @return    {this}                              An IdentityWallet instance
   */
  function IdentityWallet(getConsent) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    (0, _classCallCheck2["default"])(this, IdentityWallet);
    if (typeof getConsent !== 'function') throw new Error('getConsent parameter has to be a function'); // TODO - getConsent should remember past consents

    this._getConsent = getConsent;
    this.events = new _events["default"]();

    if (config.seed) {
      this._seed = config.seed;
    } else if (config.authSecret) {
      this._authSecret = config.authSecret;
    } else if (config.externalAuth) {
      this._externalAuth = config.externalAuth;
    } else {
      throw new Error('Either seed, or authSecret has to be passed to create an IdentityWallet instance');
    }
  }
  /**
   * Get the 3IDProvider
   *
   * @return    {ThreeIdProvider}                   The 3IDProvider for this IdentityWallet instance
   */


  (0, _createClass2["default"])(IdentityWallet, [{
    key: "get3idProvider",
    value: function get3idProvider() {
      return new _threeIdProvider["default"](this);
    }
    /**
     * Determine if consent has been given for spaces for a given origin
     *
     * @param     {Array<String>}     spaces          The desired spaces
     * @param     {String}            origin          Application domain
     * @param     {String}            opt.address     Optional address (managementKey) if keyring not available yet
     * @return    {Boolean}                           True if consent has already been given
     */

  }, {
    key: "hasConsent",
    value: function hasConsent() {
      var spaces = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var origin = arguments.length > 1 ? arguments[1] : undefined;

      var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
          address = _ref.address;

      var key = address || this._keyring.getPublicKeys().managementKey;

      var prefix = "3id_consent_".concat(key, "_").concat(origin, "_");

      var consentExists = function consentExists(space) {
        return Boolean(_store["default"].get(prefix + space));
      };

      return spaces.reduce(function (acc, space) {
        return acc && consentExists(space);
      }, consentExists());
    }
    /**
    *  Get consent for given spaces for a given origin
    *
    * @param     {Array<String>}     spaces          The desired spaces
    * @param     {String}            origin          Application domain
    * @param     {String}            opt.address     Optional address (managementKey) if keyring not available yet
    * @return    {Boolean}                           True consent was given
    */

  }, {
    key: "getConsent",
    value: function getConsent() {
      var spaces,
          origin,
          _ref2,
          address,
          consent,
          key,
          prefix,
          saveConsent,
          _args = arguments;

      return _regenerator["default"].async(function getConsent$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              spaces = _args.length > 0 && _args[0] !== undefined ? _args[0] : [];
              origin = _args.length > 1 ? _args[1] : undefined;
              _ref2 = _args.length > 2 && _args[2] !== undefined ? _args[2] : {}, address = _ref2.address;

              if (this.hasConsent(spaces, origin, {
                address: address
              })) {
                _context.next = 14;
                break;
              }

              _context.next = 6;
              return _regenerator["default"].awrap(this._getConsent({
                type: 'authenticate',
                origin: origin,
                spaces: spaces,
                opts: {
                  address: address
                }
              }));

            case 6:
              consent = _context.sent;

              if (consent) {
                _context.next = 9;
                break;
              }

              return _context.abrupt("return", false);

            case 9:
              key = address || this._keyring.getPublicKeys().managementKey;
              prefix = "3id_consent_".concat(key, "_").concat(origin, "_");

              saveConsent = function saveConsent(space) {
                return _store["default"].set(prefix + space, true);
              };

              saveConsent();
              spaces.map(saveConsent);

            case 14:
              return _context.abrupt("return", true);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "getLink",
    value: function getLink() {
      return _regenerator["default"].async(function getLink$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (!this._seed) {
                _context2.next = 7;
                break;
              }

              this._keyring = new _keyring["default"](this._seed);
              _context2.next = 4;
              return _regenerator["default"].awrap(this._get3id());

            case 4:
              this.DID = _context2.sent;
              delete this._seed;

              this._linkManagementAddress();

            case 7:
              return _context2.abrupt("return", this._keyring ? this._keyring.getPublicKeys().managementKey : _keyring["default"].walletForAuthSecret(this._authSecret).address);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_linkManagementAddress",
    value: function _linkManagementAddress() {
      var managementWallet;
      return _regenerator["default"].async(function _linkManagementAddress$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              managementWallet = this._keyring.managementWallet();
              _context3.t0 = this.events;
              _context3.next = 4;
              return _regenerator["default"].awrap((0, _idBlockchainUtils.createLink)(this.DID, managementWallet.address, (0, _utils.fakeEthProvider)(managementWallet)));

            case 4:
              _context3.t1 = _context3.sent;

              _context3.t0.emit.call(_context3.t0, 'new-link-proof', _context3.t1);

            case 6:
            case "end":
              return _context3.stop();
          }
        }
      }, null, this);
    }
    /**
     * Link a blockchain address to the identity. Usually the address
     * would be an ethereum address (EOA or EIP1271 compatible contract)
     * and the provider is an JSON-RPC provider that can sign a message
     * with this address using personal_sign.
     *
     * @param     {String}        address          The address to link
     * @param     {Object}        provider         The provider that can sign a message for the given address
     * @return    {Object}                         The link proof object
     */

  }, {
    key: "linkAddress",
    value: function linkAddress(address, provider) {
      var proof;
      return _regenerator["default"].async(function linkAddress$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (this._keyring) {
                _context4.next = 2;
                break;
              }

              throw new Error('This method can only be called after authenticate has been called');

            case 2:
              _context4.next = 4;
              return _regenerator["default"].awrap((0, _idBlockchainUtils.createLink)(this.DID, address, provider));

            case 4:
              proof = _context4.sent;
              this.events.emit('new-link-proof', proof);
              return _context4.abrupt("return", proof);

            case 7:
            case "end":
              return _context4.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "linkManagementKey",
    value: function linkManagementKey() {
      var timestamp, msg;
      return _regenerator["default"].async(function linkManagementKey$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              if (!this._externalAuth) {
                _context5.next = 2;
                break;
              }

              return _context5.abrupt("return", null);

            case 2:
              timestamp = Math.floor(new Date().getTime() / 1000);
              msg = "Create a new 3Box profile\n\n- \nYour unique profile ID is ".concat(this.DID, " \nTimestamp: ").concat(timestamp);
              _context5.t0 = msg;
              _context5.t1 = timestamp;
              _context5.next = 8;
              return _regenerator["default"].awrap(this._keyring.managementPersonalSign(msg));

            case 8:
              _context5.t2 = _context5.sent;
              return _context5.abrupt("return", {
                msg: _context5.t0,
                timestamp: _context5.t1,
                sig: _context5.t2
              });

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_initKeyring",
    value: function _initKeyring(authData, address, spaces) {
      var _this = this;

      var seed, migratedKeys, proof, _seed;

      return _regenerator["default"].async(function _initKeyring$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!this._seed) {
                _context6.next = 5;
                break;
              }

              _context6.next = 3;
              return _regenerator["default"].awrap(this.getLink());

            case 3:
              _context6.next = 37;
              break;

            case 5:
              if (!(authData && authData.length > 0)) {
                _context6.next = 15;
                break;
              }

              authData.find(function (_ref3) {
                var ciphertext = _ref3.ciphertext,
                    nonce = _ref3.nonce;
                seed = _keyring["default"].decryptWithAuthSecret(ciphertext, nonce, _this._authSecret);
                return Boolean(seed);
              });

              if (seed) {
                _context6.next = 9;
                break;
              }

              throw new Error('No valid auth-secret for this identity');

            case 9:
              this._keyring = new _keyring["default"](seed);
              _context6.next = 12;
              return _regenerator["default"].awrap(this._get3id());

            case 12:
              this.DID = _context6.sent;
              _context6.next = 37;
              break;

            case 15:
              if (!this._externalAuth) {
                _context6.next = 31;
                break;
              }

              if (address) {
                _context6.next = 18;
                break;
              }

              throw new Error('External authentication requires an address');

            case 18:
              _context6.next = 20;
              return _regenerator["default"].awrap(this._externalAuth({
                address: address,
                spaces: spaces,
                type: '3id_migration'
              }));

            case 20:
              migratedKeys = _context6.sent;
              this._keyring = new _keyring["default"](null, migratedKeys);
              _context6.next = 24;
              return _regenerator["default"].awrap(this._get3id());

            case 24:
              this.DID = _context6.sent;
              _context6.next = 27;
              return _regenerator["default"].awrap(this._externalAuth({
                address: address,
                type: '3id_createLink',
                did: this.DID
              }));

            case 27:
              proof = _context6.sent;
              if (proof) this.events.emit('new-link-proof', proof);
              _context6.next = 37;
              break;

            case 31:
              // no authData available so we create a new identity
              _seed = '0x' + Buffer.from(_keyring["default"].naclRandom(32)).toString('hex');
              this._keyring = new _keyring["default"](_seed);
              _context6.next = 35;
              return _regenerator["default"].awrap(this._get3id());

            case 35:
              this.DID = _context6.sent;
              this.addAuthMethod(this._authSecret);

            case 37:
            case "end":
              return _context6.stop();
          }
        }
      }, null, this);
    }
    /**
     * Authenticate to given spaces
     *
     * @param     {Array<String>}     spaces          The desired spaces
     * @param     {Object}    opts                    Optional parameters
     * @param     {Array<Object>}     opts.authData   The authData for this identity
     * @return    {Object}                            The public keys for the requested spaces of this identity
     */

  }, {
    key: "authenticate",
    value: function authenticate() {
      var _this2 = this;

      var spaces,
          _ref4,
          authData,
          address,
          origin,
          consent,
          result,
          _args7 = arguments;

      return _regenerator["default"].async(function authenticate$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              spaces = _args7.length > 0 && _args7[0] !== undefined ? _args7[0] : [];
              _ref4 = _args7.length > 1 && _args7[1] !== undefined ? _args7[1] : {}, authData = _ref4.authData, address = _ref4.address;
              origin = _args7.length > 2 ? _args7[2] : undefined;

              if (!address) {
                _context7.next = 7;
                break;
              }

              _context7.next = 6;
              return _regenerator["default"].awrap(this.getConsent(spaces, origin, {
                address: address
              }));

            case 6:
              consent = _context7.sent;

            case 7:
              if (!(!this._keyring || this._externalAuth)) {
                _context7.next = 10;
                break;
              }

              _context7.next = 10;
              return _regenerator["default"].awrap(this._initKeyring(authData, address, spaces));

            case 10:
              if (!address) consent = this.getConsent(spaces, origin);

              if (consent) {
                _context7.next = 13;
                break;
              }

              throw new Error('Authentication not authorized by user');

            case 13:
              result = {
                main: this._keyring.getPublicKeys(),
                spaces: {}
              };
              spaces.map(function (space) {
                result.spaces[space] = _this2._keyring.getPublicKeys({
                  space: space,
                  uncompressed: true
                });
              });
              return _context7.abrupt("return", result);

            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, null, this);
    }
    /**
     * Check if authenticated to given spaces
     *
     * @param     {Array<String>}     spaces          The desired spaces
     * @param     {String}            origin          Application domain
     * @param     {String}            opt.address     Optional address (managementKey) if keyring not available yet
     * @return    {Boolean}                           True if authenticated
     */

  }, {
    key: "isAuthenticated",
    value: function isAuthenticated() {
      var spaces,
          origin,
          _ref5,
          address,
          _args8 = arguments;

      return _regenerator["default"].async(function isAuthenticated$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              spaces = _args8.length > 0 && _args8[0] !== undefined ? _args8[0] : [];
              origin = _args8.length > 1 ? _args8[1] : undefined;
              _ref5 = _args8.length > 2 && _args8[2] !== undefined ? _args8[2] : {}, address = _ref5.address;
              return _context8.abrupt("return", Boolean(this._keyring) && this.hasConsent(spaces, origin, {
                address: address
              }));

            case 4:
            case "end":
              return _context8.stop();
          }
        }
      }, null, this);
    }
    /**
     * Add a new authentication method for this identity
     *
     * @param     {String}    authSecret              A 32 byte hex string used as authentication secret
     */

  }, {
    key: "addAuthMethod",
    value: function addAuthMethod(authSecret) {
      var message, encAuthData, authWallet;
      return _regenerator["default"].async(function addAuthMethod$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              if (this._keyring) {
                _context9.next = 2;
                break;
              }

              throw new Error('This method can only be called after authenticate has been called');

            case 2:
              message = this._keyring._seed;
              encAuthData = _keyring["default"].encryptWithAuthSecret(message, authSecret);
              this.events.emit('new-auth-method', encAuthData); // A link from the authSecret is created in order to find
              // the DID if we don't know the seed

              authWallet = _keyring["default"].walletForAuthSecret(authSecret);
              _context9.t0 = this.events;
              _context9.next = 9;
              return _regenerator["default"].awrap((0, _idBlockchainUtils.createLink)(this.DID, authWallet.address, (0, _utils.fakeEthProvider)(authWallet)));

            case 9:
              _context9.t1 = _context9.sent;

              _context9.t0.emit.call(_context9.t0, 'new-link-proof', _context9.t1);

            case 11:
            case "end":
              return _context9.stop();
          }
        }
      }, null, this);
    }
    /**
     * Sign a verifiable credential. The format of the credential is [did-jwt](https://github.com/uport-project/did-jwt).
     *
     * @param     {Object}    payload                 The payload of the claim
     * @param     {Object}    opts                    Optional parameters
     * @param     {String}    opts.space              The space used to sign the claim
     * @param     {String}    opts.expiresIn          Set an expiry date for the claim as unix timestamp
     * @return    {String}                            The signed claim encoded as a JWT
     */

  }, {
    key: "signClaim",
    value: function signClaim(payload) {
      var _ref6,
          DID,
          space,
          expiresIn,
          issuer,
          settings,
          _args10 = arguments;

      return _regenerator["default"].async(function signClaim$(_context10) {
        while (1) {
          switch (_context10.prev = _context10.next) {
            case 0:
              _ref6 = _args10.length > 1 && _args10[1] !== undefined ? _args10[1] : {}, DID = _ref6.DID, space = _ref6.space, expiresIn = _ref6.expiresIn;

              if (this._keyring) {
                _context10.next = 3;
                break;
              }

              throw new Error('This method can only be called after authenticate has been called');

            case 3:
              _context10.t0 = DID;

              if (_context10.t0) {
                _context10.next = 8;
                break;
              }

              _context10.next = 7;
              return _regenerator["default"].awrap(this._get3id(space));

            case 7:
              _context10.t0 = _context10.sent;

            case 8:
              issuer = _context10.t0;
              settings = {
                signer: this._keyring.getJWTSigner(space),
                issuer: issuer,
                expiresIn: expiresIn
              };
              return _context10.abrupt("return", _didJwt["default"].createJWT(payload, settings));

            case 11:
            case "end":
              return _context10.stop();
          }
        }
      }, null, this);
    }
    /**
     * Encrypt a message
     *
     * @param     {String}    message                 The message to be encrypted
     * @param     {String}    space                   The space used for encryption
     * @param     {Object}    opts                    Optional parameters
     * @param     {String}    opts.to                 The public key to encrypt the message to
     * @param     {String}    opts.nonce              The nonce used to encrypt the message
     * @param     {String}    opts.blockSize          The blockSize used for padding (default 24)
     * @return    {Object}                            The encrypted object (ciphertext and nonce)
     */

  }, {
    key: "encrypt",
    value: function encrypt(message, space) {
      var _ref7,
          nonce,
          blockSize,
          to,
          paddedMsg,
          _args11 = arguments;

      return _regenerator["default"].async(function encrypt$(_context11) {
        while (1) {
          switch (_context11.prev = _context11.next) {
            case 0:
              _ref7 = _args11.length > 2 && _args11[2] !== undefined ? _args11[2] : {}, nonce = _ref7.nonce, blockSize = _ref7.blockSize, to = _ref7.to;

              if (this._keyring) {
                _context11.next = 3;
                break;
              }

              throw new Error('This method can only be called after authenticate has been called');

            case 3:
              paddedMsg = typeof message === 'string' ? (0, _utils.pad)(message, blockSize) : message;

              if (!to) {
                _context11.next = 8;
                break;
              }

              return _context11.abrupt("return", this._keyring.asymEncrypt(paddedMsg, to, {
                nonce: nonce
              }));

            case 8:
              return _context11.abrupt("return", this._keyring.symEncrypt(paddedMsg, {
                space: space,
                nonce: nonce
              }));

            case 9:
            case "end":
              return _context11.stop();
          }
        }
      }, null, this);
    }
    /**
     * Decrypt a message
     *
     * @param     {Object}    encryptedObject         The encrypted object (ciphertext, nonce, and ephemeralFrom for asymmetric encrypted objects)
     * @param     {String}    space                   The space used for encryption
     * @return    {String}                            The decrypted message
     */

  }, {
    key: "decrypt",
    value: function decrypt(encObj, space, toBuffer) {
      var paddedMsg;
      return _regenerator["default"].async(function decrypt$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              if (this._keyring) {
                _context12.next = 2;
                break;
              }

              throw new Error('This method can only be called after authenticate has been called');

            case 2:
              if (encObj.ephemeralFrom) {
                paddedMsg = this._keyring.asymDecrypt(encObj.ciphertext, encObj.ephemeralFrom, encObj.nonce, {
                  space: space,
                  toBuffer: toBuffer
                });
              } else {
                paddedMsg = this._keyring.symDecrypt(encObj.ciphertext, encObj.nonce, {
                  space: space,
                  toBuffer: toBuffer
                });
              }

              if (paddedMsg) {
                _context12.next = 5;
                break;
              }

              throw new Error('IdentityWallet: Could not decrypt message');

            case 5:
              return _context12.abrupt("return", toBuffer ? paddedMsg : (0, _utils.unpad)(paddedMsg));

            case 6:
            case "end":
              return _context12.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "hashDBKey",
    value: function hashDBKey(key, space) {
      var salt;
      return _regenerator["default"].async(function hashDBKey$(_context13) {
        while (1) {
          switch (_context13.prev = _context13.next) {
            case 0:
              salt = this._keyring.getDBSalt(space);
              return _context13.abrupt("return", (0, _utils.sha256Multihash)(salt + key));

            case 2:
            case "end":
              return _context13.stop();
          }
        }
      }, null, this);
    }
  }, {
    key: "_get3id",
    value: function _get3id(space) {
      var pubkeys, doc, payload, signature;
      return _regenerator["default"].async(function _get3id$(_context14) {
        while (1) {
          switch (_context14.prev = _context14.next) {
            case 0:
              pubkeys = this._keyring.getPublicKeys({
                space: space,
                uncompressed: true
              });
              doc = new _ipfsDidDocument["default"](_utils.fakeIpfs, DID_METHOD_NAME);

              if (space) {
                _context14.next = 11;
                break;
              }

              if (!this.DID) {
                _context14.next = 5;
                break;
              }

              return _context14.abrupt("return", this.DID);

            case 5:
              doc.addPublicKey('signingKey', 'Secp256k1VerificationKey2018', 'publicKeyHex', pubkeys.signingKey);
              doc.addPublicKey('encryptionKey', 'Curve25519EncryptionPublicKey', 'publicKeyBase64', pubkeys.asymEncryptionKey);
              doc.addPublicKey('managementKey', 'Secp256k1VerificationKey2018', 'ethereumAddress', pubkeys.managementKey);
              doc.addAuthentication('Secp256k1SignatureAuthentication2018', 'signingKey');
              _context14.next = 21;
              break;

            case 11:
              doc.addPublicKey('subSigningKey', 'Secp256k1VerificationKey2018', 'publicKeyHex', pubkeys.signingKey);
              doc.addPublicKey('subEncryptionKey', 'Curve25519EncryptionPublicKey', 'publicKeyBase64', pubkeys.asymEncryptionKey);
              doc.addAuthentication('Secp256k1SignatureAuthentication2018', 'subSigningKey');
              doc.addCustomProperty('space', space);
              doc.addCustomProperty('root', this.DID);
              payload = {
                subSigningKey: pubkeys.signingKey,
                subEncryptionKey: pubkeys.asymEncryptionKey,
                space: space,
                iat: null
              };
              _context14.next = 19;
              return _regenerator["default"].awrap(this.signClaim(payload));

            case 19:
              signature = _context14.sent.split('.')[2];
              doc.addCustomProperty('proof', {
                alg: 'ES256K',
                signature: signature
              });

            case 21:
              _context14.next = 23;
              return _regenerator["default"].awrap(doc.commit({
                noTimestamp: true
              }));

            case 23:
              return _context14.abrupt("return", doc.DID);

            case 24:
            case "end":
              return _context14.stop();
          }
        }
      }, null, this);
    }
  }]);
  return IdentityWallet;
}();

module.exports = IdentityWallet;